import axios from 'axios'
import { URIS, loadHeaders } from '../Uris'
import { errorMessage } from '../helpers'

export const FETCH_CLUB = 'FETCH_CLUB'
export const FETCH_CLUB_SUCCESS = 'FETCH_CLUB_SUCCESS'
export const FETCH_CLUB_FAILURE = 'FETCH_CLUB_FAILURE'
export const SAVE_CLUB_SUCCESS = 'SAVE_CLUB_SUCCESS'
export const SAVE_CLUB_FAILURE = 'SAVE_CLUB_FAILURE'
export const CLUB_AJAX_CALL = 'CLUB_AJAX_CALL'
export const CLUB_CLEAR_AJAX_CALL = 'CLUB_CLEAR_AJAX_CALL'
export const UPLOAD_SIGNATURE_STARTED = 'UPLOAD_SIGNATURE_STARTED'
export const UPLOAD_SIGNATURE_SUCCESS = 'UPLOAD_SIGNATURE_SUCCESS'
export const UPLOAD_SIGNATURE_FAILURE = 'UPLOAD_SIGNATURE_FAILURE'

export function loadClub() {
  return (dispatch) => {
    dispatch(fetchClub())
    axios({
      method: 'GET',
      url: URIS.club,
      headers: loadHeaders()
    })
      .then((res) => {
        dispatch(fetchClubSuccess(res.data))
      })
      .catch((error) => {
        dispatch(fetchClubFailure(errorMessage(error)))
      })
  }
}

function fetchClub() {
  return {
    type: FETCH_CLUB
  }
}

function fetchClubSuccess(payload) {
  return {
    type: FETCH_CLUB_SUCCESS,
    payload
  }
}

function fetchClubFailure(payload) {
  return {
    type: FETCH_CLUB_FAILURE,
    payload
  }
}

export function saveClub(payload) {
  return (dispatch) => {
    dispatch(loadingAjaxCall())
    axios({
      method: 'POST',
      url: URIS.club,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(saveClubSuccess(res.data))
      })
      .catch((error) => {
        dispatch(saveClubFailure(errorMessage(error)))
      })
  }
}

function saveClubSuccess(payload) {
  return {
    type: SAVE_CLUB_SUCCESS,
    payload
  }
}

function saveClubFailure(payload) {
  return {
    type: SAVE_CLUB_FAILURE,
    payload
  }
}

function loadingAjaxCall() {
  return {
    type: CLUB_AJAX_CALL
  }
}

export function clearAjaxCall(payload) {
  return {
    type: CLUB_CLEAR_AJAX_CALL
  }
}

export function uploadSignatureStarted() {
  return {
    type: UPLOAD_SIGNATURE_STARTED
  }
}

export function uploadSignature(payload) {
  return (dispatch) => {
    axios({
      method: 'PUT',
      url: URIS.club,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(uploadSignatureSuccess(res.data))
      })
      .catch(() => {
        dispatch(uploadSignatureFailure())
      })
  }
}

function uploadSignatureSuccess(payload) {
  return {
    type: UPLOAD_SIGNATURE_SUCCESS,
    payload
  }
}

function uploadSignatureFailure() {
  return {
    type: UPLOAD_SIGNATURE_FAILURE
  }
}



// WEBPACK FOOTER //
// ./src/actions/Club.js